module.exports = __webpack_public_path__ + "img/logo-security.c6500d96.svg";